<template>
  <app-content class="h-panel">
    <div class="flex justify-between p-20px pb-0px">
      <div class="flex">
        <DropdownCustom ref="paramsDropdown" button class="h-btn-primary mr-20px" trigger="click">
          <div v-if="params.start!==params.end">{{ fqFormat(params.start) }} 至 {{ fqFormat(params.end) }}</div>
          <div v-else>{{ fqFormat(params.start) }}</div>
          <template #content>
            <Form style="padding: 10px;width: 400px">
              <FormItem class="!pb-5px" label="会计期间">
                <div class="flex items-center">
                  <Select @change="dateCheck" v-model="params.start" :deletable="false" :datas="checkoutSelect"/>
                  <span class="mx-8px">至</span>
                  <Select @change="dateCheck" v-model="params.end" :deletable="false" :datas="checkoutSelect"/>
                </div>
              </FormItem>
              <FormItem class="!pb-5px" label="科目">
                <Select :datas="subjectList" :filter="filter" keyName="id" titleName="fullName"
                        v-model="params.subjectId">
                  <template #show="{value}">
                    {{ value.code }} {{ value.fullName }}
                  </template>
                  <template #item="{item}">
                    {{ item.code }} {{ item.fullName }}
                  </template>
                </Select>
              </FormItem>
              <FormItem class="!pb-5px" label="科目级别">
                <div class="flex items-center">
                  <Select v-model="params.levelStart" :deletable="false" filterable :datas="levelOptions"/>
                  <span class="mx-8px">至</span>
                  <Select v-model="params.levelEnd" :deletable="false" filterable :datas="levelOptions"/>
                </div>
              </FormItem>
              <!-- //格式化数量 AABV-->
            <FormItem class="!pb-5px" label="数量小数">
              <div class="flex items-center">
                <div><Radio v-model="quantityRadio" :datas="quantity" @change="changeQuantityRadio"></Radio></div>
              </div>
            </FormItem>
              <FormItem class="!pb-5px">
                <Button color="primary" @click="loadList();loadAuxiliaryList();" :loading="loading">确定</Button>
                <Button @click="this.$refs.paramsDropdown.hide()">取消</Button>
                <Button @click="resetForm">重置</Button>
              </FormItem>
            </Form>
          </template>
        </DropdownCustom>
        <Select type="object" v-model="auxiliary" :deletable="false" style="min-width: 100px" :datas="auxiliaryType"
                keyName="id" titleName="name"/>
      </div>
      <div class=" flex items-center">
        <Checkbox class="mr-16px" v-model="showNumPrice">显示数量金额</Checkbox>
        <vxe-button @click="exportData" icon="fa fa-download" content="导出"/>
        <vxe-button @click="continuousPrint('out')" icon="fa fa-print" content="连续导出"/>
        <vxe-button @click="printData" icon="fa fa-print" content="打印"/>
        <vxe-button @click="continuousPrint" icon="fa fa-print" content="连续打印"/>
        <!-- jxd连续导出弹出 -->
        <Modal v-model="outModel" v-bind="paramsStyle">
          <div style="margin-bottom: 10px;font-size: 16px;">注意：</div>
          <div >是否导出全部核算项目明细账？</div>
          <div style="margin-top:10px ;display: flex;justify-content: right;">
            <vxe-button @click="outModel=false" icon="vxe-icon-undo" content="取消"/>
            <vxe-button @click="outModel=false;outStart()" icon="vxe-icon-print" :loading="isReadyOut" content="开始导出"/>
          </div>
        </Modal>
        <!-- jxd连续打印弹出 -->
        <Modal v-model="printModelAux" v-bind="paramsStyle">
          <div style="margin-bottom: 10px;font-size: 16px;">注意：</div>
          <div >是否打印全部核算项目明细账？</div>
          <div style="margin-top:10px ;display: flex;justify-content: right;">
            <vxe-button @click="printModelAux=false" icon="vxe-icon-undo" content="取消"/>
            <vxe-button v-print="printAccAux" @click="printModelAux=false" icon="vxe-icon-print" :loading="isReadyPrints" content="开始打印"/>
          </div>
        </Modal>
      </div>
    </div>

    <div class="text-center mb-16px font-bold text-20px">{{ auxiliaryItem.name ? auxiliaryItem.name : '' }} {{ title }} 明细账</div>
    <div class="h-panel-body flex">
      <div style="overflow-x: auto;flex: 1;height: calc(100vh - 290px)" class="mr-8px">
        <vxe-table ref="xTable" :data="dataList" height="auto" border stripe>
          <vxe-column title="日期" field="voucherDate" width="11%" align="center"/>
          <vxe-column title="凭证字号" field="voucherId" width="8%" align="center">
            <template #default="{row}">
              <router-link class="text-hover primary-color" @success="loadList()" width="1120px"
                           v-if="row.voucherId"
                           :to="{name:'VoucherForm',params:{voucherId:row.voucherId}}">
                {{ row.word }}-{{ row.code }}
              </router-link>
            </template>
          </vxe-column>
          <vxe-column title="科目" field="subjectName" width="14%"/>
          <vxe-column title="摘要" field="summary" width="20%"/>

          <!-- 普通模式：只显示金额 -->
          <template v-if="!showNumPrice">
            <vxe-column title="借方" field="debitAmount" width="14%" align="right" formatter="toMoney"/>
            <vxe-column title="贷方" field="creditAmount" width="14%" align="right" formatter="toMoney"/>
            <vxe-column title="方向" field="balanceDirection" align="center" width="5%"/>
            <vxe-column title="余额" field="balance" width="14%" align="right" formatter="toMoney"/>
          </template>

          <!-- 数量金额模式：显示数量、单价、金额 -->
          <template v-else>
            <vxe-colgroup title="借方发生额" header-align="center">
              <vxe-column title="数量" field="debitQuantity" width="6%" align="right" :formatter="['toQuantity', quantityRadio]"/>
              <vxe-column title="单价" field="debitPrice" width="6%" align="right" formatter="formatPrice"/>
              <vxe-column title="金额" field="debitAmount" align="right" formatter="toMoney" width="6%"/>
            </vxe-colgroup>
            <vxe-colgroup title="贷方发生额" header-align="center">
              <vxe-column title="数量" field="creditQuantity" width="6%" align="right" :formatter="['toQuantity', quantityRadio]"/>
              <vxe-column title="单价" field="creditPrice" width="6%" align="right" formatter="formatPrice"/>
              <vxe-column title="金额" field="creditAmount" align="center" width="6%" formatter="toMoney"/>
            </vxe-colgroup>
            <vxe-colgroup title="余额" header-align="center">
              <vxe-column title="方向" field="balanceDirection" align="center" width="7%"/>
              <vxe-column title="数量" field="endQuantity" width="6%" align="right" :formatter="['toQuantity', quantityRadio]"/>
              <vxe-column title="单价" field="endPrice" width="6%" align="right" formatter="formatPrice"/>
              <vxe-column title="金额" field="balance" align="right" width="6%" formatter="toMoney"/>
            </vxe-colgroup>
          </template>
        </vxe-table>
      </div>
      <div style="overflow: scroll;max-height: calc(100vh - 290px);width: 212px;">
        <Tree @select="doSelect" :option="param" ref="auxiliary" filterable
              className="h-tree-theme-row-selected"></Tree>
      </div>
    </div>
    <!-- 连续打印原生模版jxd -->
    <div style="width: 0;height:0; overflow: hidden;">
      <div id="printMeAux">
        <div v-for="(item,index) in allData" style="width:100%;page-break-before:always;margin:0 auto">
          <p style="font-size: 16px;font-weight: bold;">{{ item.name }}核算项目明细账</p>
          <div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
            <span>科目：{{item.name}}</span>
            <span> {{item.date}} </span>
            <span> 单位：元 </span>
          </div>
          <table style="margin-bottom:4px;margin-top: 4px;border-collapse:collapse;width:100%;">
            <thead style="font-weight:bold;">
            <tr>
              <th style="height:36px;border:1px solid;padding:2px;width:75px;font-size: 14px;">日期</th>
              <th style="height:36px;border:1px solid;padding:2px;width:45px;font-size: 14px;">凭证字号</th>
              <th style="height:36px;border:1px solid;padding:2px;width:145px;font-size: 14px;">科目</th>
              <th style="height:36px;border:1px solid;padding:2px;width:165px;font-size: 14px;">摘要</th>
              <!-- 普通模式表头 -->
              <template v-if="!showNumPrice">
                <th style="height:36px;border:1px solid;padding:2px;width:87px;font-size: 14px;">借方</th>
                <th style="height:36px;border:1px solid;padding:2px;width:87px;font-size: 14px;">贷方</th>
                <th style="height:36px;border:1px solid;padding:2px;width:35px;font-size: 14px;">方向</th>
                <th style="height:36px;border:1px solid;padding:2px;width:87px;font-size: 14px;">余额</th>
              </template>
              <!-- 数量金额模式表头 -->
              <template v-else>
                <th colspan="3" style="height:36px;border:1px solid;padding:2px;font-size: 14px;">借方发生额</th>
                <th colspan="3" style="height:36px;border:1px solid;padding:2px;font-size: 14px;">贷方发生额</th>
                <th colspan="3" style="height:36px;border:1px solid;padding:2px;font-size: 14px;">余额</th>
              </template>
            </tr>
            <!-- 数量金额模式的第二行表头 -->
            <tr v-if="showNumPrice">
              <th style="height:30px;border:1px solid;padding:2px;width:50px;font-size: 12px;">数量</th>
              <th style="height:30px;border:1px solid;padding:2px;width:50px;font-size: 12px;">单价</th>
              <th style="height:30px;border:1px solid;padding:2px;width:50px;font-size: 12px;">金额</th>
              <th style="height:30px;border:1px solid;padding:2px;width:50px;font-size: 12px;">数量</th>
              <th style="height:30px;border:1px solid;padding:2px;width:50px;font-size: 12px;">单价</th>
              <th style="height:30px;border:1px solid;padding:2px;width:50px;font-size: 12px;">金额</th>
              <th style="height:30px;border:1px solid;padding:2px;width:35px;font-size: 12px;">方向</th>
              <th style="height:30px;border:1px solid;padding:2px;width:50px;font-size: 12px;">数量</th>
              <th style="height:30px;border:1px solid;padding:2px;width:50px;font-size: 12px;">单价</th>
              <th style="height:30px;border:1px solid;padding:2px;width:50px;font-size: 12px;">金额</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(items,index) in item.data">
              <td style="height:30px;text-align: center; font-size: 12px;border:1px solid;padding:2px;width:75px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">{{ items.voucherDate }}</td>
              <td style="height:30px;text-align: center;font-size: 12px;border:1px solid;padding:2px;width:45px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                <span v-if="items.voucherId">{{ items.word }} - {{ items.code }}</span>
              </td>
              <td style="height:30px;font-size: 12px;border:1px solid;padding:2px;width:145px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">{{ items.subjectName }}</td>
              <!-- jxd word-break: break-all;让纯数字也能换行 -->
              <td style="height:30px;font-size: 12px;border:1px solid;padding:2px;width:165px; word-break: break-all;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">{{ items.summary }}</td>
              <!-- 普通模式数据 -->
              <template v-if="!showNumPrice">
                <td style="text-align: right; height:30px;font-size: 12px;border:1px solid;padding:2px;width:87px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                  <span v-if="items.debitAmount">{{ items.debitAmount.toFixed(2) }}</span>
                </td>
                <td style="text-align: right;height:30px;font-size: 12px;border:1px solid;padding:2px;width:87px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                  <span v-if="items.creditAmount">{{ items.creditAmount.toFixed(2) }}</span>
                </td>
                <td style="height:30px;text-align: center;font-size: 12px;border:1px solid;padding:2px;width:35px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">{{ items.balanceDirection }}</td>
                <td style="height:30px;text-align: right;font-size: 12px;border:1px solid;padding:2px;width:87px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                  <span v-if="items.balance">{{ items.balance.toFixed(2) }}</span>
                </td>
              </template>
              <!-- 数量金额模式数据 -->
              <template v-else>
                <td style="text-align: right; height:30px;font-size: 12px;border:1px solid;padding:2px;width:50px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                  <span v-if="items.debitQuantity">{{ items.debitQuantity }}</span>
                </td>
                <td style="text-align: right; height:30px;font-size: 12px;border:1px solid;padding:2px;width:50px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                  <span v-if="items.debitPrice">{{ formatPriceValue(items.debitPrice) }}</span>
                </td>
                <td style="text-align: right; height:30px;font-size: 12px;border:1px solid;padding:2px;width:50px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                  <span v-if="items.debitAmount">{{ items.debitAmount.toFixed(2) }}</span>
                </td>
                <td style="text-align: right; height:30px;font-size: 12px;border:1px solid;padding:2px;width:50px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                  <span v-if="items.creditQuantity">{{ items.creditQuantity }}</span>
                </td>
                <td style="text-align: right; height:30px;font-size: 12px;border:1px solid;padding:2px;width:50px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                  <span v-if="items.creditPrice">{{ formatPriceValue(items.creditPrice) }}</span>
                </td>
                <td style="text-align: right; height:30px;font-size: 12px;border:1px solid;padding:2px;width:50px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                  <span v-if="items.creditAmount">{{ items.creditAmount.toFixed(2) }}</span>
                </td>
                <td style="height:30px;text-align: center;font-size: 12px;border:1px solid;padding:2px;width:35px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">{{ items.balanceDirection }}</td>
                <td style="text-align: right; height:30px;font-size: 12px;border:1px solid;padding:2px;width:50px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                  <span v-if="items.endQuantity">{{ items.endQuantity }}</span>
                </td>
                <td style="text-align: right; height:30px;font-size: 12px;border:1px solid;padding:2px;width:50px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                  <span v-if="items.endPrice">{{ formatPriceValue(items.endPrice) }}</span>
                </td>
                <td style="text-align: right; height:30px;font-size: 12px;border:1px solid;padding:2px;width:50px;word-wrap: break-word;white-space: normal;overflow-wrap: break-word;">
                  <span v-if="items.balance">{{ items.balance.toFixed(2) }}</span>
                </td>
              </template>
            </tr>
            </tbody>
          </table>
          <div style="display:flex;justify-content: left;;height:22px;line-height:22px">编制单位：{{ currentAccountSets.companyName }}</div>
        </div>
      </div>
    </div>
  </app-content>
</template>

<script>
import BooUtil from "@/views/accountbook/bookUtil";
import accountbook from "@/api/accountbook";
import {downloadBlob} from "download.js";
import manba from "manba";
import {mapGetters, mapState} from "vuex";
import {clone} from "xe-utils";
import setting from "@/api/setting";
const DEFAULT_VALUE = {
  closeOnMask: false,
  fullScreen: false,
  middle: true,
  hasMask: true,
  hasDivider: false,
  hasCloseIcon: true,
  draggable: false
};
export default {
  name: "AuxiliaryAccountingDetail",
  data() {
    return {
      quantityRadio: 2,//格式化数量AABV
      quantity: [{ title: '2位', key: 2 },{ title: '4位', key: 4 },{ title: '6位', key: 6 }],//格式化数量AABV
      outModel: false,
      isReadyOut:true,
      paramsStyle: {
        ...DEFAULT_VALUE
      },
      isReadyPrints:true,
      printModelAux:false,
      allData:[],
      // jxd原生连续打印
      printAccAux: {
        id: "printMeAux", // 这里是要打印元素的ID
        popTitle: "&nbsp", // 打印的标题
        // extraCss: "", // 打印可引入外部的一个 css 文件
        // extraHead: "", // 打印头部文字
        // preview: true, // 是否启动预览模式，默认是false
        // previewTitle: '打印客户账单', // 打印预览的标题
        // previewPrintBtnLabel: '预览结束，开始打印', // 打印预览的标题下方的按钮文本，点击可进入打印
        // zIndex: 10002, // 预览窗口的z-index，默认是20002，最好比默认值更高
        previewBeforeOpenCallback () { console.log('正在加载预览窗口！'); }, // 预览窗口打开之前的callback
        previewOpenCallback () { console.log('已经加载完预览窗口，预览打开了！') }, // 预览窗口打开时的callback
        beforeOpenCallback () { console.log('开始打印之前！') }, // 开始打印之前的callback
        openCallback () { console.log('执行打印了！') }, // 调用打印时的callback
        closeCallback () { console.log('关闭了打印工具！') }, // 关闭打印的callback(无法区分确认or取消)
        clickMounted () { console.log('点击v-print绑定的按钮了！') },
      },
      dataList: [],
      subjectList: [],
      loading: false,
      showNumPrice: false,
      quantityRadio: 2, // 数量小数位数
      param: {
        keyName: 'id',
        parentName: 'parentId',
        titleName: 'name',
        dataMode: 'list',
        datas: []
      },
      params: {
        start: null,
        end: null,
        levelStart: 1,
        levelEnd: 4,
        currencyId: null,
        subjectId: null,
      },
      accountDate: null,
      auxiliary: null,
      auxiliaryItem: {},
      auxiliaryType: [],
      tablePrint: {
        // 自定义打印的样式示例
        style: `
          /* 整个表格的基础样式 */
          .vxe-table {
            font-family: "Microsoft YaHei", 微软雅黑, "MicrosoftJhengHei", 华文细黑, STHeiti, MingLiu; // 设置表格整体字体
          }

          /* 表头单元格 */
          .vxe-table thead th {
            border: 1px solid #000;
            font-size: 14px;
            word-break: break-all;
            overflow-wrap: break-word;
          }

          /* 表体单元格（即数据行的所有单元格） */
          .vxe-body--column,
          .vxe-table tbody td {
            border: 1px solid #000;
            font-size: 12px;
            word-break: break-all;
            overflow-wrap: break-word;
          }
        `,
        beforePrintMethod: ({ content }) => {
          const headerHtml = `<h3>${this.auxiliaryItem.name} 核算项目明细账</h3>
            <div style="display:flex;justify-content: space-between;height:22px;line-height:22px">
                <span>${this.auxiliary.name}：${this.auxiliaryItem.name}</span>
                <span> ${this.title} </span>
                <span> 单位：元 </span>
            </div>
          `;
          const footerHtml = `<div style="display:flex;justify-content: left;;height:22px;line-height:22px">编制单位：${this.currentAccountSets.companyName}</div>`;
          return `${headerHtml}${content}${footerHtml}`;
        },
      },
    }
  },
  computed: {
    ...mapState(['currentAccountSets','User']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    levelOptions(){
      // 安全检查：确保路径上的对象都存在
      const encoding = this.User?.accountSets?.encoding;
      let array = [];
      for(let i = 0;i<encoding.length;i++){
        array.push(i+1)
      }
      return array;
    },
    title() {
      if (!this.params.start) {
        return '';
      }
      if (this.params.start === this.params.end) {
        return manba(this.params.start).format("YYYY年MM期")
      }
      return manba(this.params.start).format("YYYY年MM期") + " - " + manba(this.params.end).format("YYYY年MM期");
    },
    queryParams() {
      return Object.assign({}, this.params, {
        categoryType: this.auxiliary ? this.auxiliary.categoryType : null,
        categoryId: this.auxiliary ? this.auxiliary.id : null,
        detailId: this.auxiliaryItem ? this.auxiliaryItem.id : null
      })
    },
    queryAuxiliaryParams() {
      return Object.assign({}, this.params, {
        categoryType: this.auxiliary ? this.auxiliary.categoryType : null,
        categoryId: this.auxiliary ? this.auxiliary.id : null
      })
    }
  },
  watch: {
    auxiliary() {
      this.loadAuxiliaryList();
    }
  },
  methods: {
    //格式化数量 AABV
    changeQuantityRadio(data){
      this.quantityRadio = data.key;
    },
    outStart(){
      console.log("我执行",this.param.datas.length,this.allData.length)
      const utils = new BooUtil(this.$refs.xTable, '\n')
      let header = utils.header;
      let date,code,subject,summary,debitAmount,creditAmount,balanceDirection,balance;
      let debitQuantity,debitPrice,creditQuantity,creditPrice,endQuantity,endPrice;

      // 根据showNumPrice设置不同的字段
      if (this.showNumPrice) {
        // 直接使用 field 名称来映射，更可靠
        const allColumns = this.$refs.xTable.getColumns();

        console.log('所有列信息:', allColumns);

        // 通过 field 属性直接查找对应的列ID
        allColumns.forEach(col => {
          console.log(`列: field=${col.field}, id=${col.id}, title=${col.title}`);

          switch(col.field) {
            case 'voucherDate':
              date = col.id;
              break;
            case 'voucherId':
              code = col.id;
              break;
            case 'subjectName':
              subject = col.id;
              break;
            case 'summary':
              summary = col.id;
              break;
            case 'debitQuantity':
              debitQuantity = col.id;
              break;
            case 'debitPrice':
              debitPrice = col.id;
              break;
            case 'debitAmount':
              debitAmount = col.id;
              break;
            case 'creditQuantity':
              creditQuantity = col.id;
              break;
            case 'creditPrice':
              creditPrice = col.id;
              break;
            case 'creditAmount':
              creditAmount = col.id;
              break;
            case 'balanceDirection':
              balanceDirection = col.id;
              break;
            case 'endQuantity':
              endQuantity = col.id;
              break;
            case 'endPrice':
              endPrice = col.id;
              break;
            case 'balance':
              balance = col.id;
              break;
          }
        });

        // 检查关键字段是否获取成功
        console.log('数量金额模式字段映射结果:', {
          date, code, subject, summary,
          debitQuantity, debitPrice, debitAmount,
          creditQuantity, creditPrice, creditAmount,
          balanceDirection, endQuantity, endPrice, balance
        });

        // 如果关键字段未获取到，给出提示
        if (!debitQuantity || !debitPrice || !creditQuantity || !creditPrice || !endQuantity || !endPrice) {
          const missingFields = [];
          if (!debitQuantity) missingFields.push('借方数量');
          if (!debitPrice) missingFields.push('借方单价');
          if (!creditQuantity) missingFields.push('贷方数量');
          if (!creditPrice) missingFields.push('贷方单价');
          if (!endQuantity) missingFields.push('余额数量');
          if (!endPrice) missingFields.push('余额单价');

          this.$Message({
            type: 'error',
            text: `数量金额字段映射失败，缺少: ${missingFields.join('、')}`
          });
          console.error('缺少的字段:', missingFields);
          return;
        }
      } else {
        const allColumns = this.$refs.xTable.getColumns();

        allColumns.forEach(col => {
          switch(col.field) {
            case 'voucherDate':
              date = col.id;
              break;
            case 'voucherId':
              code = col.id;
              break;
            case 'subjectName':
              subject = col.id;
              break;
            case 'summary':
              summary = col.id;
              break;
            case 'debitAmount':
              debitAmount = col.id;
              break;
            case 'creditAmount':
              creditAmount = col.id;
              break;
            case 'balanceDirection':
              balanceDirection = col.id;
              break;
            case 'balance':
              balance = col.id;
              break;
          }
        });
      }

      if (this.param.datas.length && this.allData.length) {
        //组装每个dataList
        console.log(this.allData,666666)
        let allDataList = []
        this.allData.forEach((item,index)=>{
          let dataList = []
          item.data.forEach((item2,index2)=>{
            let obj = {
              [date]:item2.voucherDate,
              [code]:(item2.word && item2.code) ? item2.word + "-" + item2.code : '',
              [subject]:item2.subjectName,
              [summary]:item2.summary,
            }

            // 根据模式添加不同字段
            if (this.showNumPrice) {
              obj[debitQuantity] = item2.debitQuantity;
              obj[debitPrice] = this.formatPriceValue(item2.debitPrice);
              obj[debitAmount] = item2.debitAmount;
              obj[creditQuantity] = item2.creditQuantity;
              obj[creditPrice] = this.formatPriceValue(item2.creditPrice);
              obj[creditAmount] = item2.creditAmount;
              obj[balanceDirection] = item2.balanceDirection;
              obj[endQuantity] = item2.endQuantity;
              obj[endPrice] = this.formatPriceValue(item2.endPrice);
              obj[balance] = item2.balance;
            } else {
              obj[debitAmount] = item2.debitAmount;
              obj[creditAmount] = item2.creditAmount;
              obj[balanceDirection] = item2.balanceDirection;
              obj[balance] = item2.balance;
            }

            dataList.push(obj)
          })
          let subjectName = item.name;
          console.log(subjectName)
          let obj2 = {[subjectName]:dataList}
          allDataList.push(obj2)
        })
        console.log(allDataList,888)

        // 计算所有行数总和
        let totalCount = 0;

        allDataList.forEach(item => {
          // 获取对象中的第一个（也是唯一一个）键值对
          const key = Object.keys(item)[0];
          console.log(key)
          const array = item[key];
          totalCount += array.length;
        });
        console.log(totalCount)

        if(totalCount > 10000){
          this.$Message({
            type:'warn',
            text: `导出数据量过大，请选择单个科目导出或减少查询时间范围！`
          });
        }else if(totalCount == 0){
          this.$Message({
            type:'warn',
            text: `导出的数据为空，请检查查询条件！`
          });
        }else{
          accountbook.downloads({header: utils.header, dataList: allDataList}).then((data) => {
            downloadBlob(`${this.title}-${this.currentAccountSets.companyName}-批量导出辅助明细账.xls`, data)
          })
        }
      }
    },
    resetForm(){
      this.params.levelStart = 1
      this.params.levelEnd = 4
      this.params.currencyId = null
      this.params.subjectId = null
    },
    dateCheck(){
      // 定义开始时间和结束时间
      let startDate = new Date(this.params.start);
      let endDate = new Date(this.params.end);
      if(startDate > endDate){
        this.$Message({
          type:'warn',
          text: `开始时间必须早于或等于结束时间！`
        });
      }
    },
    continuousPrint(type = '') {
      console.log(type)
      if(type == 'out'){
        this.isReadyOut = true;
        this.outModel = true;
      }else{
        this.printModelAux = true;
        this.isReadyPrints = true;
      }
      this.allData = [];
      let promiseChain = Promise.resolve();

      this.param.datas.forEach((item, index) => {
        promiseChain = promiseChain.then(() => {
          const obj = {
            categoryId: this.queryParams.categoryId,
            categoryType: this.queryParams.categoryType,
            currencyId: this.queryParams.categoryId,
            detailId: item.id,
            end: this.queryParams.end,
            levelEnd: this.queryParams.levelEnd,
            levelStart: this.queryParams.levelStart,
            start: this.queryParams.start,
          };

          return accountbook.loadAuxiliaryDetails(obj).then(({ data }) => {
            this.conPrint(data, item.name);

            // 可以根据实际需求决定是否在此处返回数据
            return data;
          });
        });
      });

      promiseChain.finally(() => {
        if(type == 'out'){
          this.isReadyOut = false;
        }else{
          this.isReadyPrints = false;
        }
      });
    },
    // continuousPrint() {
    //   this.allData = [];
    //   this.printModelAux = true;
    //   this.isReadyPrints = true;
    //   // 将所有异步请求包装在数组中
    //   const promises = this.param.datas.map(item => {
    //     let obj = {
    //       categoryId: this.queryParams.categoryId,
    //       categoryType: this.queryParams.categoryType,
    //       currencyId: this.queryParams.categoryId,
    //       detailId: item.id,
    //       end: this.queryParams.end,
    //       levelEnd: this.queryParams.levelEnd,
    //       levelStart: this.queryParams.levelStart,
    //       start: this.queryParams.start,
    //     };
    //     // 返回每个异步操作的Promise
    //     return accountbook.loadAuxiliaryDetails(obj).then(({ data }) => {
    //       this.conPrint(data, item.name);
    //     });
    //   });
    //   // 等待所有异步请求完成
    //   Promise.all(promises).then(() => {
    //     this.isReadyPrints = false;
    //   });
    // },
    //存储连续打印的科目数据处理
    conPrint(data,name){
      console.log(data,name);
      let obj = {
        name,
        data,
        date:this.title
      };
      console.log(obj)
      this.allData.push(obj);
    },
    filter(item, val) {
      return item.code.indexOf(val) !== -1 || item.name.indexOf(val) !== -1 || item.mnemonicCode.indexOf(val) !== -1;
    },
    formatPrice({ cellValue }) {
      if (cellValue === null || cellValue === undefined || cellValue === 0) {
        return '';
      }
      return Number(cellValue).toFixed(2);
    },
    formatPriceValue(value) {
      if (value === null || value === undefined || value === 0) {
        return '';
      }
      return Number(value).toFixed(2);
    },
    loadAuxiliaryType() {
      setting.accountingCategory.list().then(({data}) => {
        this.auxiliaryType = data;
        if (data) {
          this.auxiliary = data[0];
        }
      });
    },
    loadList() {
      // console.log(this.auxiliary,this.auxiliaryItem);
      this.loading = true;
      accountbook.loadAuxiliaryDetails(this.queryParams).then(({data}) => {
        this.dataList = data;
        this.$refs.paramsDropdown.hide();
      }).finally(() => {
        this.loading = false;
      });
    },
    loadAuxiliaryList() {
      this.dataList = [];
      let params = {...this.queryAuxiliaryParams}
      delete params['detailId']
      accountbook.loadAuxiliary(params).then(({data}) => {
        data.forEach(val => val.name = val.code + " " + val.name);
        // data = data.sort((a, b) => a.code.localeCompare(b.code));
        data = data.sort((a, b) => Number(a.code) - Number(b.code));//jxd 按数值排序
        this.param.datas = data;
        if (data.length) {
          this.auxiliaryItem = data[0];
          this.loadList();
          this.$nextTick(() => {
            this.$refs.auxiliary.updateSelect(this.auxiliaryItem.id);
          });
        }
      });
    },
    doSearch() {
      this.loadAuxiliaryList();
    },
    doSelect(node) {
      this.auxiliaryItem = node;
      this.params.detailId = node.id;
      this.loadList();
    },
    exportData() {
      const utils = new BooUtil(this.$refs.xTable, '\n')
      accountbook.download({header: utils.header, dataList: utils.dataList}).then((data) => {
        downloadBlob(`${this.auxiliary ? this.auxiliary.name + '-' : ''}${this.auxiliaryItem ? this.auxiliaryItem.name + '-' : ''}${manba(this.accountDate).format("YYYY年MM期")}-明细账.xls`, data)
      })
    },
    printData() {
      // 获取VXE-Table实例
      const xTable = this.$refs.xTable;
      // 调用打印方法，并传入打印配置
      xTable.print({
        ...this.tablePrint,
      });
    },
  },
  mounted() {
    const encodingRule = this.User.accountSets.encoding || '4222';
    const maxLevel = encodingRule.length;
    this.params.levelEnd = maxLevel;


    this.params.start = manba(this.currentAccountSets.currentAccountDate).format("YYYY-M");
    this.params.end = this.params.start;
    this.params.currencyId = this.localCurrency.id;
    this.cloneParams = clone(this.params, true)
    this.loadAuxiliaryType();


    // setting.subject.voucherSelect({all: true}).then(({data}) => {
    //   this.subjectList = data;
    // })
    //jxd这里的科目选择应该是所有科目
    setting.subject.listAll().then(({data}) => {
      this.subjectList = data;
    })
  }
}
</script>
<style lang="less" scoped>
::v-deep .h-tree-li{
  overflow: visible !important;
}
</style>